import React from "react";
import GroupsAutocomplete, { OptionType } from "../../../common/controls/GroupsAutocomplete";
import createCustomEvent from "../../../common/utils/createCustomEvent";

export interface IProps {
	refControl: string,
	filter: string,
	errorText: string,
	name: string,
	onSet?: (value: OptionType) => void,
	counters?: string,
}

export default function GroupCombobox(props: IProps) {
	const [value, setValue] = React.useState<OptionType>(null);
	const idControlRef = React.useRef<HTMLInputElement>();
	const nameControlRef = React.useRef<HTMLInputElement>();

	React.useEffect(() => {
		idControlRef.current = document.querySelector("input[data-ref='" + props.refControl + "_id']");
		nameControlRef.current = document.querySelector("input[data-ref='" + props.refControl + "_name']");

		if (idControlRef.current.value) {
			let nv = {
				value: idControlRef.current.value,
				label: nameControlRef.current.value,
			}
			setValue(nv);

			if (props.onSet)
				props.onSet(nv);
		}
	}, []);

	let counter = props.counters;
	if (!counter) {
		switch (props.name) {
			case "ExecutorGroup":
				counter = "ExecutorInIssuesCounter"
				break;
			case "AssignedToGroup":
				counter = "AssignedInIssuesCounter"
				break;
			case "CoordinatorGroup":
				counter = "CoordinatorInIssuesCounter"
				break;
		}
	}

	return <GroupsAutocomplete
		className="qd-combocoxs-control"
		value={value}
		onChange={(v) => {
			setValue(v);
			idControlRef.current.value = v?.value ?? "";
			nameControlRef.current.value = v?.label ?? "";

			let event = createCustomEvent("change");
			idControlRef.current.dispatchEvent(event);

			if (props.onSet)
				props.onSet(v);
		}}
		errorText={props.errorText}
		filter={props.filter}
		counter={counter}
	/>
}